import {MdArrowForward} from 'react-icons/md';
import {useInfiniteGetColumnPostList} from '../../../../core/repositories/columnRepository';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {CardContainer} from '../../../columns/components/List/Card/container';
import {COLUMNS_LATEST} from '../../../columns/components/List/routes';
import {SectionHeader} from './Presenter/SectionHeader';

type Props = {
  componentId: string;
  title?: string;
  isLogin?: boolean;
};

export const NewColumnSection = ({
  componentId,
  title = '新着コラム',
  isLogin = false,
}: Props) => {
  const {data} = useInfiniteGetColumnPostList({
    queryParam: {
      limit: 10,
    },
  });
  const columnJoinList =
    data?.pages.flatMap((page) => (page.ok ? page.value.posts : [])) ?? [];

  return (
    <div id={componentId} className="px-4 pc:w-[1200px]">
      <SectionHeader
        componentId={componentId}
        title={title}
        href={isLogin ? COLUMNS_LATEST : undefined}
      />
      <div className="flex overflow-x-scroll mt-16 gap-16">
        {columnJoinList.map((post) => (
          <div key={post.id} className="flex-shrink-0 w-[300px]">
            <CardContainer
              id={post.id}
              title={post.title}
              clipCount={post.favoriteCount}
              isClipped={post.favorited}
              tagNames={post.tags}
              thumbnail={post.carouselThumbnailURL}
              updatedAt={post.updateDateTime}
              sponsoredOption={{
                enabled: false,
              }}
              componentId={`${componentId}-item`}
            />
          </div>
        ))}
        {isLogin && columnJoinList.length >= 10 && (
          <CommonLink
            href={COLUMNS_LATEST}
            className="shadow-card bg-white p-16 rounded-16 hover:opacity-70 m-4 flex items-center"
            data-gtm-click={`${componentId}-more`}
          >
            <div className="flex justify-center py-16">
              <MdArrowForward size={40} />
            </div>
            <div>
              <div className="text-md text-black text-center w-[200px]">
                もっと見る
              </div>
            </div>
          </CommonLink>
        )}
      </div>
    </div>
  );
};
